import { render, staticRenderFns } from "./ProductNav.vue?vue&type=template&id=0bf5c40c&scoped=true&"
import script from "./ProductNav.vue?vue&type=script&lang=js&"
export * from "./ProductNav.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0bf5c40c",
  null
  
)

export default component.exports